import React, { useEffect } from "react";
import OfferSettings from "../components/Settings/OfferSettings";
import NotificationsSettings from "../components/Settings/NotificationsSettings";
import ProfileSettings from "../components/Settings/ProfileSettings";
import GlobalSettings from "../components/Settings/GlobalSettings";
import MfaSettings from "../components/Settings/MfaSettings";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLayoutContext } from "../context/LayoutContext";
import MiniSiteSettings from "./MiniSiteSettings";

const Settings = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const {
    userSettings,
    setUserSettings,
    systemError,
    setSystemError,
    loading,
    setLoading,
    error,
    setError,
    success,
    setSuccess,
    modalScreen,
    setModalScreen,
    page,
    setPage,
  } = useLayoutContext();
  const [activeTab, setActiveTab] = React.useState<
    "profile" | "offers" | "notifications" | "security" | "settings"
  >("profile");

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login", { state: { from: pathname } });
    }
  }, [isAuthenticated, navigate, pathname]);

  if (!isAuthenticated) {
    return <div className="container mx-auto p-4">Acesso não autorizado.</div>;
  }

  return (
    <>
      <div className="container mx-auto p-4">
        <div className="p-4 overflow-auto">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div>
              <span className="text-3xl font-bold text-gray-900 tracking-tight">
                Configurações
              </span>
              <p className="text-gray-500 mt-1">
                Gerencie suas configurações de perfil, propostas e notificações.
              </p>
            </div>
          </div>

          {loading ? (
            <div className="text-center">Loading...</div>
          ) : (
            <>
              <div className="tabs is-right">
                <ul>
                  <li
                    className={`is-${activeTab === "profile" ? "active" : ""}`}
                    onClick={() => setActiveTab("profile")}
                  >
                    <a>Profile</a>
                  </li>
                  {(userSettings?.isMainAccount() ||
                    userSettings?.isAdmin()) && (
                    <li
                      className={`is-${activeTab === "offers" ? "active" : ""}`}
                      onClick={() => setActiveTab("offers")}
                    >
                      <a>Propostas</a>
                    </li>
                  )}
                  <li
                    className={`is-${activeTab === "notifications" ? "active" : ""}`}
                    onClick={() => setActiveTab("notifications")}
                  >
                    <a>Notificações</a>
                  </li>
                  <li
                    className={`is-${activeTab === "security" ? "active" : ""}`}
                    onClick={() => setActiveTab("security")}
                  >
                    <a>Segurança</a>
                  </li>
                  {(userSettings?.isMainAccount() ||
                    userSettings?.isAdmin()) && (
                    <li
                      className={`is-${activeTab === "settings" ? "active" : ""}`}
                      onClick={() => setActiveTab("settings")}
                    >
                      <a>Configurações Globais</a>
                    </li>
                  )}
                </ul>
              </div>
              {activeTab === "profile" && <ProfileSettings />}
              {activeTab === "offers" && <OfferSettings />}
              {activeTab === "notifications" && <NotificationsSettings />}
              {activeTab === "security" && <MfaSettings />}
              {activeTab === "settings" && <GlobalSettings />}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Settings;
